<template>
	<div>
		<v-navigation-drawer
			v-model="drawer"
			:mini-variant="miniVariant"
			:clipped="clipped"
			fixed
			app
			width="270"
			color="#F5F5F5"
		>
			<v-list flat>
				<v-list-item-group color="#CC2128">
					<template v-for="(item, i) in items">
					<v-list-item :key="i" :to="item.to" router exact v-if="verificaVisibilidade(item.admin)">
						<v-list-item-action>
							<v-icon>{{ item.icon }}</v-icon>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title v-text="item.title" />
						</v-list-item-content>
					</v-list-item>
					</template>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
		<div>
			<v-app-bar
				height="80"
				class="rounded-b-xl pl-5 pr-5"
				elevation="9"
				color="#F5F5F5"
				:clipped-left="clipped"
				fixed
				rounded-b
				app
			>
				<v-container class="container-appbar">
					<v-row  no-gutters>
						<v-col cols="11">
							<v-app-bar-nav-icon @click.stop="drawer = !drawer" />
							<AppLogo />
						</v-col>
						<v-spacer />
						<v-col cols="1" class="d-flex justify-end align-center">
							<div class="d-none d-sm-inline-flex">{{ user.nome }}</div>
							<v-menu left bottom offset-y>
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on" large>
										<v-icon>account_circle</v-icon>
									</v-btn>
								</template>
								<v-list>
									<v-list-item>
										<v-list-item-icon>
											<v-icon>mdi-account-outline</v-icon>
										</v-list-item-icon>
										<v-list-item-title>{{ user.nome }}</v-list-item-title>
									</v-list-item>
									<v-divider />
									<v-list-item @click="alterarSenha()">
										<v-list-item-icon>
											<v-icon>mdi-cog-outline</v-icon>
										</v-list-item-icon>
										<v-list-item-title>Alterar senha</v-list-item-title>
									</v-list-item>
									<v-divider />
									<v-list-item @click="logout">
										<v-list-item-icon>
											<v-icon color="red">exit_to_app</v-icon>
										</v-list-item-icon>
										<v-list-item-content>Sair</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-col>
					</v-row>
				</v-container>
			</v-app-bar>
		</div>

		<AlterarSenha :abrirDialog="abrir" tipo="usuario" @dialogClose="dialogClose" :id="user.id" />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import AppLogo from '../widgets/AppLogo.vue'
import AlterarSenha from '../shared/AlterarSenha.vue'

export default {
	data() {
		return {
			clipped: false,
			drawer: false,
			fixed: false,
			abrir: false,
			items: [
				{
					icon: 'mdi-account-outline',
					title: 'Usuários',
					to: '/usuarios',
					admin: true,
				},
				{
					icon: 'mdi-office-building-outline',
					title: 'Empresas',
					to: '/empresas',
					admin: false,
				},
				{
					icon: 'mdi-account-tie-outline',
					title: 'Fornecedores',
					to: '/fornecedores',
					admin: false,
				},
			],
			miniVariant: false,
			right: true,
			rightDrawer: false,
		}
	},
	components: {
		AppLogo,
		AlterarSenha,
	},
	computed: {
		...mapState(['user']),
	},
	methods: {
		verificaVisibilidade(admin) {
			if (admin && this.$store.getters.userAdmin) {
				return true
			}
			return !admin
		},
		logout() {
			this.$store.dispatch('logout')
			window.location.reload()
			//this.$router.push('/signin')
		},
		alterarSenha() {
			this.abrir = true
		},
		dialogClose() {
			this.abrir = false
		},
	},
}
</script>

<style>
@media only screen and (max-width: 1900px) {
	.container-appbar {
		max-width: none;
	}
}
</style>



